import { Guid, MobizNotificationPriority, SerializableObject } from '../../core';

import { NotificationAction } from './notification-action.do';

export class Notification<
  E extends string = string,
  M extends Record<string, unknown> = Record<string, unknown>,
> extends SerializableObject {

  public defaultActionUrl?: string | null;
  public details: string;
  public eventCaption: string;
  public eventId: E;
  public id: Guid;
  public language: string;
  public meta: M;
  public moreActions: NotificationAction[];
  public organizationId: Guid;
  public priority: MobizNotificationPriority;
  public tags: string[] | null;
  public timeStampUtc: Date;
  public title: string;


  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'moreActions':
        const moreActions: NotificationAction[] = [];
        (propertyValue as unknown[]).forEach((partialData: unknown): void => {
          moreActions.push(new NotificationAction(partialData));
        });
        return moreActions;

      case 'timeStampUtc':
        if (typeof returnValue === 'string') {
          return new Date(returnValue);
        }
        return returnValue;

      default:
        return returnValue;
    }
  }
}
